(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.LFProductGalleryDotsLoaded) {
    window.LFProductGalleryDotsLoaded = true;

    const updateGalleryDots = (gallery, activeIndex) => {
      if (!gallery) return;

      const dots = gallery.querySelectorAll('[data-lf-gallery-dot]');

      dots.forEach((dot, index) => {
        const active = index === activeIndex;

        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    document.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-lf-gallery-dot]');
      if (!dot) return;

      event.preventDefault();
      event.stopPropagation();

      const gallery = dot.closest('.card-gallery');
      const slideshow = gallery?.querySelector('slideshow-component');
      const index = Number(dot.dataset.slideIndex);

      if (!slideshow || Number.isNaN(index)) return;

      slideshow.select(index, event);
      updateGalleryDots(gallery, index);
    });

    document.addEventListener('slideshow:select', (event) => {
      const slideshow = event.target.closest('slideshow-component');
      const gallery = slideshow?.closest('.card-gallery');

      if (!gallery || !event.detail) return;

      updateGalleryDots(gallery, event.detail.index);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
